import { useTranslations } from 'next-intl';
import type { FormTabType } from '@/app/types';
import { buildModelItems } from '@/app/utils';
import { useModelVersionText } from './use-model-version-text';
import { useUserTag } from './use-user-tag';

export const useModelItems = (type: Exclude<FormTabType, 'scene'>) => {
  const t = useTranslations();
  const { getModelVersionText } = useModelVersionText();
  const userTags = useUserTag();

  return buildModelItems({
    type,
    getModelVersionText: (modelVersion) => getModelVersionText({ modelVersion }),
    getDescription: t,
    userTags,
  });
};
